import React, { Component } from "react";
import QVFourSpeedometer from "./QVFourSpeedometer";
import QVFourSpeedometerV2 from "./QVFourSpeedometerV2";
import QVFourSellerGraphContainer from "./QVFourSellerGraphContainer";
import QVFourDotGraph from "./QVFourDotGraph";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";
import { propertyUtil } from "views/Pma/PropertyUtil";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";

class SpeedometerPage extends Component {
  componentDidMount() {
    require("./print.scss");
  }
  render() {
    const {
      quarterlyCityTable,
      agentData,
      currentArea,
      quarterlyAreaTable,
      hoData,
      printVersion,
      useSingleFamilyHomes,
      useCondosandTownhomes,
      showMedian,
    } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    const { calculateQSellersAdvantages, useAreaOrCityYEGraph } = propertyUtil;

    const {
      marketTrends: marketTrendsArea,
      marketTrendsPercentage: marketTrendsPercArea,
      graphAverages: graphAveragesArea,
      highestSalePricePast6Months,

      marketTrendsSFR: marketTrendsAreaSFH,
      marketTrendsPercentageSFR: marketTrendsPercAreaSFH,
      graphAveragesSFR: graphAveragesAreaSFH,
      marketTrendsCNDTH: marketTrendsAreaCNDTH,
      marketTrendsPercentageCNDTH: marketTrendsPercCNDTH,
      graphAveragesCNDTH: graphAveragesAreaCNDTH,
    } = quarterlyAreaTable;

    const {
      marketTrends: marketTrendsCity,
      marketTrendsPercentage: marketTrendsPercCity,
      graphAverages: graphAveragesCity,
    } = quarterlyCityTable;

    let useMedian =
      showMedian || listgenUserID === "102548" || listgenUserID === "105801";

    let useYearOverYear = false;
    let lastYearSalePrice = marketTrendsArea.filter(
      (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
    )[0].AvgSalePrice;

    if (highestSalePricePast6Months === "0" || lastYearSalePrice === "0") {
      useYearOverYear = true;
    }
    // show 12 months data (1-Year vs Past 1-Year) on the dashboard for this agent/area
    if (listgenUserID === "103052" && mlsAreaID === "48D") {
      useYearOverYear = true;
    }

    let currentYearObjArea;
    let currentYearAreaPerc;
    let pastYearObjArea;
    let use6MonthsOver6Months = false;
    console.log("this.props", this.props);
    if (useYearOverYear) {
      currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "1-Year Trending",
      );
      currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "1 Year Trends Percentage",
      );
      pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Past 1-Year Trending",
      );
    } else if (useCondosandTownhomes) {
      currentYearObjArea = marketTrendsAreaCNDTH.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      );
      currentYearAreaPerc = marketTrendsPercCNDTH.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      );
      pastYearObjArea = marketTrendsAreaCNDTH.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      );
    } else if (useSingleFamilyHomes) {
      currentYearObjArea = marketTrendsAreaSFH.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      );
      currentYearAreaPerc = marketTrendsPercAreaSFH.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      );
      pastYearObjArea = marketTrendsAreaSFH.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      );
    } else {
      currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      );
      currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      );
      pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      );
    }

    let currentYearObjCity = marketTrendsCity.filter(
      (obj) => obj.TrendName === "6-Months Trending",
    );

    let currentYearCityPerc = marketTrendsPercCity.filter(
      (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
    );

    const pastYearObjCity = marketTrendsCity.filter(
      (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
    );

    //-------
    // let currentYearObjArea = marketTrendsArea.filter(
    //   (obj) => obj.TrendName === "1-Year Trending"
    // );
    //
    // let currentYearAreaPerc = marketTrendsPercArea.filter(
    //   (obj) => obj.TrendPercentageName === "1 Year Trends Percentage"
    // );
    // const pastYearObjArea = marketTrendsArea.filter(
    //   (obj) => obj.TrendName === "Past 1-Year Trending"
    // );
    // let currentYearObjCity = marketTrendsCity.filter(
    //   (obj) => obj.TrendName === "1-Year Trending"
    // );
    // let currentYearCityPerc = marketTrendsPercCity.filter(
    //   (obj) => obj.TrendPercentageName === "1 Year Trends Percentage"
    // );
    // const pastYearObjCity = marketTrendsCity.filter(
    //   (obj) => obj.TrendName === "Past 1-Year Trending"
    // );
    //--------
    // let currentYearObjArea = marketTrendsArea.filter(
    //   (obj) => obj.TrendName === "Current Year First Half Trending"
    // );
    // let currentYearAreaPerc = marketTrendsPercArea.filter(
    //   (obj) =>
    //     obj.TrendPercentageName ===
    //     "Current Year First Half - Last Year Second Half Trends Percentage"
    // );
    // const pastYearObjArea = marketTrendsArea.filter(
    //   (obj) => obj.TrendName === "Past Year Second Half Trending"
    // );
    //
    // let currentYearObjCity = marketTrendsCity.filter(
    //   (obj) => obj.TrendName === "Current Year First Half Trending"
    // );
    //
    // let currentYearCityPerc = marketTrendsPercCity.filter(
    //   (obj) =>
    //     obj.TrendPercentageName ===
    //     "Current Year First Half - Last Year Second Half Trends Percentage"
    // );
    // const pastYearObjCity = marketTrendsCity.filter(
    //   (obj) => obj.TrendName === "Past Year Second Half Trending"
    // );

    const calculateSellersAdvantages = calculateQSellersAdvantages(
      ...currentYearAreaPerc,
      ...currentYearObjArea,
      ...currentYearCityPerc,
      ...currentYearObjCity,
    );

    const { areaSellersAdvantages, citySellersAdvantages } =
      calculateSellersAdvantages;

    // let determineCityOrArea = useAreaOrCityYEGraph(
    //   calculateSellersAdvantages,
    //   mlsAreaID
    // );
    let determineCityOrArea = "area";
    if (listgenUserID === "109954" || listgenUserID === "106145") {
      determineCityOrArea = "city";
    }
    let belowSpeedometerDisclaimer = false;

    return (
      <div className={`${printVersion ? "print" : "editor"}-qv4-second-left`}>
        <QVFourSpeedometerV2
          currentArea={currentArea}
          quarterlyCityTable={quarterlyCityTable}
          quarterlyAreaTable={quarterlyAreaTable}
          determineCityOrArea={determineCityOrArea}
          areaSellersAdvantages={areaSellersAdvantages}
          citySellersAdvantages={citySellersAdvantages}
          calculateSellersAdvantages={calculateSellersAdvantages}
          hoData={hoData}
          currentYearObjArea={currentYearObjArea}
          pastYearObjArea={pastYearObjArea}
          currentYearObjCity={currentYearObjCity}
          pastYearObjCity={pastYearObjCity}
          agentData={agentData}
          useSingleFamilyHomes={useSingleFamilyHomes}
          useCondosandTownhomes={useCondosandTownhomes}
          showMedian={showMedian}
          useMedian={useMedian}
        />
        <QVFourSellerGraphContainer
          agentData={agentData}
          quarterlyCityTable={quarterlyCityTable}
          quarterlyAreaTable={quarterlyAreaTable}
          marketTrendsArea={
            useCondosandTownhomes
              ? marketTrendsAreaCNDTH
              : useSingleFamilyHomes
                ? marketTrendsAreaSFH
                : marketTrendsArea
          }
          marketTrendsPercArea={
            useCondosandTownhomes
              ? marketTrendsPercCNDTH
              : useSingleFamilyHomes
                ? marketTrendsPercAreaSFH
                : marketTrendsPercArea
          }
          marketTrendsCity={marketTrendsCity}
          marketTrendsPercCity={marketTrendsPercCity}
          calculateSellersAdvantages={calculateSellersAdvantages}
          graphAveragesArea={
            useCondosandTownhomes
              ? graphAveragesAreaCNDTH
              : useSingleFamilyHomes
                ? graphAveragesAreaSFH
                : graphAveragesArea
          }
          graphAveragesCity={graphAveragesCity}
          determineCityOrArea={determineCityOrArea}
          currentYearObjArea={currentYearObjArea}
          currentYearObjCity={currentYearObjCity}
          currentYearAreaPerc={currentYearAreaPerc}
          currentYearCityPerc={currentYearCityPerc}
          pastYearObjArea={pastYearObjArea}
          pastYearObjCity={pastYearObjCity}
          printVersion={printVersion}
          currentArea={currentArea}
          useMedian={useMedian}
          useYearOverYear={useYearOverYear}
          useCondosandTownhomes={useCondosandTownhomes}
        />
        {belowSpeedometerDisclaimer && (
          <div className="below-speedometer-disclaimer">
            <p></p>
          </div>
        )}
        <QVFourEmailAndWebsiteFooter
          agentData={agentData}
          currentArea={currentArea}
          printVersion={printVersion}
        />
      </div>
    );
  }
}

export default SpeedometerPage;
